import { useLogin } from "api/Auth/auth";
import { Spinner } from "components";
import { createAlert } from "components/Alert/Alert";
import InputField from "components/InputField/InputField";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

export default function Login() {
  const { role } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const { mutate: login, isPending } = useLogin();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  useEffect(() => {
    if (role === "admin") navigate("/dashboard");
    if (role === "customer") navigate("/cp");
  }, [role, navigate]);

  const handleSubmitLogin = async (e) => {
    e.preventDefault();
    if (email === "" || password === "") {
      createAlert("Warning", "جميع الحقول مطلوبة.");
      return;
    }
    if (password.length < 8) {
      createAlert("Warning", "كلمة المرور يجب أن تكون 8 محارف على الأقل.");
      return;
    }
    login({ email, password });
  };

  return (
    <div
      className="min-h-[80vh] flex justify-center items-center w-full px-4 py-12"
      id="login-page"
      dir="rtl"
    >
      {/* الحاوية الرئيسية الزجاجية */}
      <section className="relative grid md:grid-cols-2 w-full max-w-4xl bg-white/70 dark:bg-gray-800/50 backdrop-blur-xl rounded-[2.5rem] border border-white/40 dark:border-white/10 shadow-[0_20px_50px_rgba(0,0,0,0.05)] overflow-hidden">
        {/* الجانب الأيمن: الفورم */}
        <div className="p-8 md:p-12 flex flex-col justify-center">
          <div className="mb-8">
            <h2 className="text-3xl font-bold text-gray-800 dark:text-white mb-2">
              مرحباً بك مجدداً
            </h2>
            <p className="text-gray-500 dark:text-gray-400 text-sm font-medium">
              قم بتسجيل الدخول لمتابعة تسوق أحدث اللابتوبات
            </p>
          </div>

          <form onSubmit={handleSubmitLogin} className="flex flex-col gap-5">
            <div className="space-y-1">
              <InputField
                title={"البريد الإلكتروني أو رقم الهاتف"}
                id="emailAddress"
                type="text"
                value={email}
                onChange={(e) => setEmail(e.value)}
                direction="ltr"
                className="rounded-2xl border-gray-100 dark:bg-gray-700/50"
              />
            </div>

            <div className="space-y-1">
              <InputField
                title={"كلمة المرور"}
                id="password"
                type={"password"}
                value={password}
                onChange={(e) => setPassword(e.value)}
                direction="ltr"
                className="rounded-2xl border-gray-100 dark:bg-gray-700/50"
              />
            </div>

            <div className="flex flex-col gap-3 my-2">
              <div className="flex items-center justify-between_ gap-1 text-xs">
                <span className="text-gray-400 font-medium">
                  ليس لديك حساب؟
                </span>
                <Link
                  to="/register"
                  className="text-mainLight hover:underline font-bold"
                >
                  إنشاء حساب جديد
                </Link>
              </div>
              <div className="flex items-center justify-between_ gap-1 text-xs">
                <span className="text-gray-400 font-medium">
                  نسيت كلمة السر؟
                </span>
                <Link
                  to="/forgot-my-password"
                  size="sm"
                  className="text-gray-600 dark:text-gray-300 hover:text-mainLight font-bold transition-colors"
                >
                  استعادة الآن
                </Link>
              </div>
            </div>

            <button
              disabled={isPending}
              className=" group relative h-14 w-full py-4 bg-mainLight text-white rounded-[1.5rem] font-bold shadow-lg shadow-mainLight/30 hover:shadow-mainLight/50 hover:-translate-y-1 active:scale-95 transition-all duration-300 overflow-hidden"
            >
              {!isPending ? (
                <>
                  <span className="relative z-10">دخول إلى الحساب</span>
                  <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300" />
                </>
              ) : (
                <Spinner sm />
              )}
            </button>
          </form>
        </div>

        {/* الجانب الأيسر: الشعار/الصورة */}
        <div className="hidden md:flex flex-col items-center justify-center bg-gray-50/50 dark:bg-white/5 p-12 relative overflow-hidden">
          {/* دوائر خلفية جمالية */}
          <div className="absolute top-[-10%] left-[-10%] w-64 h-64 bg-mainLight/5 rounded-full blur-3xl" />
          <div className="absolute bottom-[-10%] right-[-10%] w-64 h-64 bg-mainLight/10 rounded-full blur-3xl" />

          <img
            src="/assets/images/logo.png"
            alt="العالمية للابتوب"
            className="relative z-10 w-full max-w-[280px] drop-shadow-2xl animate-pulse-slow"
          />

          <div className="mt-8 text-center relative z-10">
            <h3 className="text-2xl font-bold text-gray-800 dark:text-white italic">
              العالمية للابتوب
            </h3>
            <p className="text-mainLight font-bold text-sm tracking-[0.2em] mt-1">
              Al-alamia Laptop
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}
